import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAppointmentDetails } from '../../../../shared/models/appointment-details.model';
import { AccordionModule } from 'primeng/accordion';
import { InformationEntityComponent } from '../../../../shared/components/information-entity/information-entity.component';
import { DatePipe } from '@angular/common';
import { TimePipe } from '../../../../shared/pipes/time.pipe';

@Component({
  selector: 'cv-appointment-details',
  standalone: true,
  imports: [AccordionModule, InformationEntityComponent, DatePipe, TimePipe],
  template: `
    <p-accordionTab [selected]="true" contentStyleClass="info-card" header="Appointment Details">
      <cv-information-entity label="Appointment Type" [value]="data.tourInformation.tourType" />
      <cv-information-entity label="Tour Date" [value]="data.tourInformation.tourDate | date: 'MM/dd/yyyy'" />
      <cv-information-entity label="Tour Time" [value]="data.tourInformation.tourTime | time: 'h:mm a'" />
    </p-accordionTab>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentDetailsComponent {
  @Input({ required: true }) data!: IAppointmentDetails;
}
